/* Floating Video — Complete JS */

(function() {
  'use strict';

  function parsePx(val, def) {
    var n = parseInt(val, 10);
    return isNaN(n) ? def : n;
  }

  class FloatingVideo {

    constructor(el) {
      this.el = el;
      this.id = el.dataset.sectionId;
      this.video = el.querySelector('.fv-video-el');
      this.closeBtn = el.querySelector('.fv-close');
      this.cardLink = el.querySelector('.fv-card');
      this.media = el.querySelector('.fv-media');

      var d = el.dataset;
      this.cfg = {
        delay: parseFloat(d.delay) || 0,
        scroll: d.scroll === 'true',
        scrollOff: parseInt(d.scrollOffset) || 500,
        closeMemory: d.closeMemory === 'true',
        closeHours: parseInt(d.closeDuration) || 24,
        mobile: d.mobile || 'show',
        autoplay: d.autoplay !== 'false',
        hide: d.hide === 'true',
      };

      this.shown = false;
      this.closed = false;
      this.storageKey = 'fv_closed_' + this.id;

      // 1. Move to body
      if (el.parentNode && el.parentNode !== document.body) {
        document.body.appendChild(el);
      }

      // 2. Apply position via JS (guaranteed, no CSS override possible)
      this.applyPosition();

      // 3. Init
      this.init();
    }

    applyPosition() {
      var el = this.el;
      var section = document.getElementById('shopify-section-' + this.id);
      var defaults = {
        width: 280,
        bottom: 20,
        side: 20,
        z: 999,
        br: 12,
        bg: '#ffffff',
        text: '#111111',
        accent: '#111111',
      };

      // Read CSS variables from section wrapper (fallback to defaults)
      var readVar = function(name, def) {
        if (section) {
          var val = getComputedStyle(section).getPropertyValue(name);
          if (val && val.trim()) return val.trim();
        }
        return String(def) + (name === '--fv-z' || name === '--fv-shadow' ? '' : 'px');
      };

      var position = 'bottom-right';
      // Try to read position from existing class
      if (el.classList.contains('fv-pos-bottom-left')) position = 'bottom-left';

      // Read from section style
      var wVal = readVar('--fv-width', defaults.width);
      var bVal = readVar('--fv-bottom', defaults.bottom);
      var sVal = readVar('--fv-side', defaults.side);
      var zVal = readVar('--fv-z', defaults.z);

      // Set inline styles (these beat ANY CSS rule)
      el.style.position = 'fixed';
      el.style.zIndex = zVal;
      el.style.width = wVal;
      el.style.maxWidth = 'calc(100vw - 30px)';

      if (position === 'bottom-left') {
        el.style.left = sVal;
        el.style.right = '';
      } else {
        el.style.right = sVal;
        el.style.left = '';
      }
      el.style.bottom = bVal;
    }

    init() {
      if (this.cfg.closeMemory && this.getStorage()) {
        this.el.style.display = 'none';
        return;
      }

      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (function(e) {
          e.stopPropagation();
          this.close();
        }).bind(this));
      }

      if (this.media) {
        this.media.addEventListener('click', (function(e) {
          if (e.target.closest('.fv-close')) return;
          this.goProduct();
        }).bind(this));
      }

      if (this.cfg.scroll) {
        this.watchScroll();
      } else if (this.cfg.delay > 0) {
        setTimeout((function() { this.show(); }).bind(this), this.cfg.delay * 1000);
      } else {
        this.show();
      }
    }

    show() {
      if (this.shown || this.closed) return;
      this.shown = true;

      if (this.cfg.hide) {
        this.el.style.display = '';
      }

      void this.el.offsetWidth;
      this.el.classList.add('fv-visible');

      if (this.video && this.cfg.autoplay) {
        this.video.play().catch(function(){});
      }
    }

    close() {
      if (this.closed) return;
      this.closed = true;
      this.el.classList.remove('fv-visible');

      if (this.cfg.closeMemory) {
        this.setStorage();
      }

      if (this.video) this.video.pause();

      setTimeout((function() {
        this.el.style.display = 'none';
      }).bind(this), 400);
    }

    goProduct() {
      if (this.cardLink && this.cardLink.href) {
        window.location.href = this.cardLink.href;
      }
    }

    watchScroll() {
      var done = false;
      var self = this;
      var fn = function() {
        if (done || self.closed || self.shown) return;
        if ((window.scrollY || window.pageYOffset) >= self.cfg.scrollOff) {
          done = true;
          if (self.cfg.delay > 0) {
            setTimeout(function() { self.show(); }, self.cfg.delay * 1000);
          } else {
            self.show();
          }
          window.removeEventListener('scroll', fn, { passive: true });
        }
      };
      window.addEventListener('scroll', fn, { passive: true });
      fn();
    }

    setStorage() {
      try {
        var expiry = Date.now() + this.cfg.closeHours * 3600000;
        localStorage.setItem(this.storageKey, JSON.stringify({ t: true, e: expiry }));
      } catch(e) {}
    }

    getStorage() {
      try {
        var raw = localStorage.getItem(this.storageKey);
        if (!raw) return false;
        var data = JSON.parse(raw);
        if (!data.t) return false;
        if (Date.now() > data.e) {
          localStorage.removeItem(this.storageKey);
          return false;
        }
        return true;
      } catch(e) {
        return false;
      }
    }
  }

  /* ---- Init ---- */
  function initFV() {
    var els = document.querySelectorAll('.floating-video');
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.__fv) continue;
      if (document.documentElement.classList.contains('shopify-design-mode')) {
        el.style.cssText = 'opacity:1;visibility:visible;pointer-events:auto;transform:none;position:relative;margin:30px auto;';
        el.classList.add('fv-visible');
        continue;
      }
      el.__fv = new FloatingVideo(el);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initFV);
  } else {
    initFV();
  }

  document.addEventListener('shopify:section:load', function() { setTimeout(initFV, 100); });
  document.addEventListener('shopify:section:reorder', function() { setTimeout(initFV, 100); });

})();
